export default "__VITE_ASSET__BKp3tLmw__"